import toast, { Toaster } from "react-hot-toast";
import { t } from "i18n";
import { sessionJustExpired } from "utils/authSession";

// Custom toast styles
const toastStyles = {
  success: {
    style: {
      background: "#F8F5F2",
      color: "#1F2937",
      border: "1px solid #E5E7EB",
      borderRadius: "0.5rem",
      padding: "1rem",
      boxShadow: "0 1px 3px 0 rgb(0 0 0 / 0.1)",
      minWidth: "300px",
      textAlign: "center",
    },
    iconTheme: {
      primary: "#059669",
      secondary: "#F8F5F2",
    },
  },
  error: {
    style: {
      background: "#F8F5F2",
      color: "#1F2937",
      border: "1px solid #E5E7EB",
      borderRadius: "0.5rem",
      padding: "1rem",
      boxShadow: "0 1px 3px 0 rgb(0 0 0 / 0.1)",
      minWidth: "300px",
      textAlign: "center",
    },
    iconTheme: {
      primary: "#DC2626",
      secondary: "#F8F5F2",
    },
  },
  loading: {
    style: {
      background: "#F8F5F2",
      color: "#1F2937",
      border: "1px solid #E5E7EB",
      borderRadius: "0.5rem",
      padding: "1rem",
      boxShadow: "0 1px 3px 0 rgb(0 0 0 / 0.1)",
      minWidth: "300px",
      textAlign: "center",
    },
  },
};

// Custom toast functions
export const showToast = {
  success: (message) => {
    toast.success(message, {
      ...toastStyles.success,
      duration: 3000,
    });
  },
  error: (message, { force = false } = {}) => {
    if (!force && sessionJustExpired()) return;
    toast.error(message, {
      ...toastStyles.error,
      duration: 4000,
    });
  },
  loading: (message) => {
    toast.loading(message, {
      ...toastStyles.loading,
    });
  },
  dismiss: (toastId) => {
    toast.dismiss(toastId);
  },
  // A success toast that stays until the user closes it — for things they
  // should notice even if they look away (e.g. a device's clock was set for
  // them). Returns the toast id.
  sticky: (message) =>
    toast.success(
      (toastItem) => (
        <span className="flex items-center gap-3">
          <span>{message}</span>
          <button
            onClick={() => toast.dismiss(toastItem.id)}
            aria-label={t("utils.toast.dismiss")}
            className="rounded px-1.5 text-base leading-none text-[#9CA3AF] hover:text-[#374151]"
          >
            ×
          </button>
        </span>
      ),
      { ...toastStyles.success, duration: Infinity }
    ),
};

// Custom Toaster component with app-wide styling
export const CustomToaster = () => {
  return (
    <Toaster
      position="bottom-center"
      toastOptions={{
        // Default options for all toasts
        duration: 3000,
        style: {
          background: "#F8F5F2",
          color: "#1F2937",
          border: "1px solid #E5E7EB",
          borderRadius: "0.5rem",
          padding: "1rem",
          boxShadow: "0 1px 3px 0 rgb(0 0 0 / 0.1)",
          minWidth: "300px",
          textAlign: "center",
        },
      }}
    />
  );
};

export default showToast;
